import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import useWithGA from '../hooks/useWithGA';
import useStrapiPageData from '../hooks/data/useStrapiPageData';
import useSearch from '../hooks/useSearch';
import useNavigation from '../hooks/useNavigation';

import MetatagsForLayout from '../components/MetatagsForLayout';

import { PAGE_SITEMAP_HTML } from '../constants/strapi';
import useTransformGatsbyData from '../hooks/useTransformGatsbyData';
import { Sitemap } from '../ui/templates/sitemap/Sitemap';
export const pageQuery = graphql`
  query SitemapRootData($pageBuildId: String!) {
    bwPageBuildData(id: { eq: $pageBuildId }) {
      data
    }
  }
`;

const LinkContent = styled.div`
  margin: 1rem 1rem 10rem;
  min-height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SitemapRootTemplate = ({ location, data, pageContext }) => {
  const bwPageBuildData = useTransformGatsbyData(data.bwPageBuildData);
  const { siteUrls, visibleSections, siteId: id } = bwPageBuildData.pageData;

  const search = useSearch();
  const { menu, footer } = useNavigation(siteUrls, location);
  const { savePageView } = useWithGA();
  const { t } = useTranslation();

  const componentData = visibleSections.map((section) => {
    return {
      title: t(section.textTid),
      href: section.mainPath,
    };
  });

  const sitemapHtmlPageData = useStrapiPageData(PAGE_SITEMAP_HTML)[1];
  const { title } = sitemapHtmlPageData;

  useEffect(() => {
    savePageView({
      type: 'SITEMAP_HTML',
    });
  }, []);

  const activeTab = -1;

  return (
    <Sitemap
      hero={{ title: title }}
      activeTab={activeTab}
      sections={[
        {
          sectionType: 'single',
          component: {
            type: 'tabs',
            componentData,
          },
        },
      ]}
      menu={menu}
      footer={footer}
      location={location}
      search={search}
      siteUrls={siteUrls}
      t={t}
    />
  );
};

SitemapRootTemplate.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default SitemapRootTemplate;

export function Head({ location, pageContext, data }) {
  const { locale } = pageContext;

  const bwPageBuildData = useTransformGatsbyData(data.bwPageBuildData);
  const { siteUrls } = bwPageBuildData.pageData;

  const sitemapHtmlPageData = useStrapiPageData(PAGE_SITEMAP_HTML)[1];
  const { seo } = sitemapHtmlPageData;

  return (
    <MetatagsForLayout
      title={seo.metaTitle}
      description={seo.metaDescription}
      pathname={location.pathname}
      locale={locale}
      siteUrls={siteUrls}
    />
  );
}
